export default function CTASection() {
  return (
    <section className="flex flex-col lg:flex-row">
      {/* Left: Image */}
      <div className="lg:w-1/2 relative min-h-[400px] lg:min-h-[550px] bg-background-100 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20overhead%20flat%20lay%20of%20modern%20shopping%20essentials%20including%20a%20sleek%20silver%20laptop%20with%20colorful%20spreadsheet%20dashboard%20on%20screen%2C%20surrounded%20by%20fashion%20accessories%20leather%20wallet%20sunglasses%20and%20a%20steaming%20ceramic%20coffee%20mug%2C%20arranged%20on%20a%20rich%20dark%20walnut%20wooden%20surface%2C%20natural%20light%20streaming%20from%20upper%20left%20creating%20soft%20shadows%2C%20sophisticated%20lifestyle%20blogger%20aesthetic%2C%20warm%20amber%20and%20deep%20brown%20tones%20with%20metallic%20accents&width=900&height=1200&seq=cta-visual-v2&orientation=portrait"
          alt="CSSBuy Spreadsheet shopping resource"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute top-6 left-6">
          <span className="text-xs font-label tracking-widest uppercase text-foreground-500">
            Free Resource Hub
          </span>
        </div>
        <div className="absolute bottom-8 left-6">
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight">
            Master Your<br />
            Shopping<br />
            With Sheets
          </h2>
        </div>
      </div>

      {/* Right: Info */}
      <div className="lg:w-1/2 flex items-center justify-center px-6 md:px-14 py-14 md:py-20 bg-background-50">
        <div className="max-w-md text-center">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight mb-6">
            Compare & Track<br />
            All in One Place
          </h2>
          <p className="text-foreground-500 text-sm md:text-base leading-relaxed mb-8">
            Stop juggling multiple tools and browser tabs. Our CSSBuy spreadsheet resources help you
            compare products, track orders, manage budgets, and make smarter shopping decisions from
            a single organized dashboard.
          </p>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center px-8 py-3.5 rounded-full bg-primary-500 text-white font-semibold text-sm whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-all duration-200"
          >
            Explore Database
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
        </div>
      </div>
    </section>
  );
}